import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=633fcf9e&scoped=true&"
import script from "./CustomerService.vue?vue&type=script&lang=js&"
export * from "./CustomerService.vue?vue&type=script&lang=js&"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=633fcf9e&lang=scss&scoped=true&"
import style1 from "./CustomerService.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633fcf9e",
  null
  
)

export default component.exports